import { useEffect, useState } from 'react'
import { FACTORY_ADDRESS } from '@icecreamswap/constants/src/common/swap'
import FactoryABI from 'config/abi/Factory.json'
import LpTokenABI from 'config/abi/lpToken.json'
import useActiveWeb3React from './useActiveWeb3React'
import { ethers } from 'ethers'

const burnAddress = '0x000000000000000000000000000000000000dead'
const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000'

export const useLpTokenStatus = (tokenAddress: string | null, pairedTokenAddress: string | null) => {
  const { provider } = useActiveWeb3React()
  const [lpTokenAddress, setLpTokenAddress] = useState<string | null>(null)
  const [burnBalance, setBurnBalance] = useState<string | null>(null)
  const [totalSupply, setTotalSupply] = useState<string | null>(null)
  const [allBurned, setAllBurned] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    if (!tokenAddress || !pairedTokenAddress || !provider) {
      setLoading(false)
      return
    }

    const main = async () => {
      setLoading(true)
      try {
        const factoryContract = new ethers.Contract(FACTORY_ADDRESS, FactoryABI, provider)
        const lpAddress: string = await factoryContract.getPair(tokenAddress, pairedTokenAddress)

        if (!lpAddress || lpAddress === ZERO_ADDRESS) {
          setLpTokenAddress(null)
          setLoading(false)
          return
        }

        setLpTokenAddress(lpAddress)

        const lpTokenContract = new ethers.Contract(lpAddress, LpTokenABI, provider)
        const [balance, supply] = await Promise.all([
          lpTokenContract.balanceOf(burnAddress),
          lpTokenContract.totalSupply(),
        ])

        setBurnBalance(balance.toString())
        setTotalSupply(supply.toString())
        setAllBurned(balance.eq(supply))
      } catch (error) {
        console.error('Error fetching LP token status:', error)
      } finally {
        setLoading(false)
      }
    }

    main()
  }, [provider, tokenAddress, pairedTokenAddress])

  return { lpTokenAddress, burnBalance, totalSupply, allBurned, loading }
}
